import { Dispatch } from "redux";
import { TaskLog } from "../../types/TaskLog";
import {
  getTaskLogs,
  getTaskLogById,
  createTaskLog,
  updateTaskLog,
  deleteTaskLog,
} from "../../services/TaskLogService";

export enum TaskLogActionList {
  ADD_TASK_LOG = "ADD_TASK_LOG",
  EDIT_TASK_LOG = "EDIT_TASK_LOG",
  FETCH_TASK_LOGS = "FETCH_TASK_LOGS",
  DELETE_TASK_LOG = "DELETE_TASK_LOG",
}

export interface AddTaskLogAction {
  type: TaskLogActionList.ADD_TASK_LOG;
  data: TaskLog;
}

export interface EditTaskLogAction {
  type: TaskLogActionList.EDIT_TASK_LOG;
  data: TaskLog;
  id: number;
}

export interface FetchTaskLogsAction {
  type: TaskLogActionList.FETCH_TASK_LOGS;
  data: TaskLog[];
}

export interface DeleteTaskLogAction {
  type: TaskLogActionList.DELETE_TASK_LOG;
  data: number;
}

export type TaskLogActions =
  | AddTaskLogAction
  | EditTaskLogAction
  | FetchTaskLogsAction
  | DeleteTaskLogAction;

export const fetchTaskLogsAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getTaskLogs();
    dispatch<FetchTaskLogsAction>({
      type: TaskLogActionList.FETCH_TASK_LOGS,
      data: response,
    });
  };
};

export const addTaskLogAction = (data: TaskLog) => {
  return async (dispatch: Dispatch) => {
    const response = await createTaskLog(data);
    dispatch<AddTaskLogAction>({
      type: TaskLogActionList.ADD_TASK_LOG,
      data: response.data.data,
    });
  };
};

export const editTaskLogAction = (id: number, data: TaskLog) => {
  return async (dispatch: Dispatch) => {
    const response = await updateTaskLog(id, data);
    dispatch<EditTaskLogAction>({
      type: TaskLogActionList.EDIT_TASK_LOG,
      data: response.data.data,
      id,
    });
  };
};

export const deleteTaskLogAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    await deleteTaskLog(id);
    dispatch<DeleteTaskLogAction>({
      type: TaskLogActionList.DELETE_TASK_LOG,
      data: id,
    });
  };
};
